import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgTypography } from "@intelligems/ig-theme";
import { AnyProgressBarWidget } from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import {
  selectedWidget,
  setSelectedWidgetVariantSettings,
} from "../../../store/slices/widgets";
import { IconGrid, IconGridItems } from "../WidgetVariants/IconGrid";
import { ProgressBarWidget1 } from "../WidgetVariants/Icons/ProgressBarWidget1";
import { ProgressBarWidget2 } from "../WidgetVariants/Icons/ProgressBarWidget2";
import { ProgressBarWidget4 } from "../WidgetVariants/Icons/ProgressBarWidget4";

interface ShippingProgressBarVariantSettingsProps {
  configType: "mobile" | "desktop";
}

export const ShippingProgressBarVariantSettings = ({
  configType,
}: ShippingProgressBarVariantSettingsProps) => {
  const progressBarWidget = useSelector(selectedWidget) as AnyProgressBarWidget;
  const dispatch = useDispatch();
  const items = useMemo<IconGridItems>(() => {
    return [
      [
        {
          icon: <ProgressBarWidget1 ispreview={true} />,
          key: "progressBarWidget1",
          checked:
            progressBarWidget?.config[configType]?.variant ===
            "progressBarWidget1",
        },
      ],
      [
        {
          icon: <ProgressBarWidget2 ispreview={true} />,
          key: "progressBarWidget2",
          checked:
            progressBarWidget?.config[configType]?.variant ===
            "progressBarWidget2",
        },
      ],
      [
        {
          icon: <ProgressBarWidget4 />,
          key: "progressBarWidget4",
          isDisabled: false,
          checked:
            progressBarWidget?.config[configType]?.variant ===
            "progressBarWidget4",
        },
      ],
    ];
  }, [progressBarWidget]);

  const onIconClick = (key: string) => {
    dispatch(setSelectedWidgetVariantSettings({ key, configType }));
  };

  return (
    <Grid container item direction={"column"} columnSpacing={2} rowSpacing={4}>
      <Grid item>
        <IgTypography sx={{ fontWeight: 600, fontSize: "14px" }}>
          Bar Styles
        </IgTypography>
      </Grid>
      <Grid container item>
        <IconGrid
          gridKey={"shipping-progress-bar-widget"}
          items={items}
          onClick={onIconClick}
        />
      </Grid>
    </Grid>
  );
};
